import styled from 'styled-components';

const SupportWrapper = styled.div`
  padding-top: 16px;
`;

export default SupportWrapper;
